import { RotateCcw, RotateCw, LayoutGrid, ZoomIn, ZoomOut } from "lucide-react";
import { segBtn } from "./LayoutModeBar";

const iconBtn = "h-9 w-9 rounded-lg border border-zinc-700 bg-zinc-900 text-zinc-200 inline-flex items-center justify-center hover:bg-zinc-800 disabled:opacity-40";
const label = "text-[10.5px] uppercase tracking-widest text-zinc-500 font-bold";

function RangeRow({ title, value, unit, min, max, step, onChange, testid, children }) {
  return (
    <div className="flex items-center gap-2 min-w-[15rem] flex-1">
      <span className={`${label} w-24 shrink-0`}>{title}</span>
      {children?.[0]}
      <input type="range" min={min} max={max} step={step} value={value} onChange={(e) => onChange(Number(e.target.value))}
        className="flex-1 accent-[#00E575]" data-testid={testid} />
      {children?.[1]}
      <span className="font-mono text-[12px] text-zinc-200 w-12 text-right" data-testid={`${testid}-value`}>{Math.round(value)}{unit}</span>
    </div>
  );
}

export function LayoutArrayControls({ angle, onAngle, landscape, onOrient, onRearrange, sizePct, onSize, zoom, setZoom, disabled }) {
  return (
    <div className="rounded-xl border border-zinc-800 bg-[#0F0F11] p-3 space-y-3" data-testid="roof-layout-array-controls">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-3">
        <RangeRow title="Alle drehen" value={angle} unit="°" min={-90} max={90} step={1} onChange={onAngle} testid="roof-layout-rotate-all">
          <button type="button" className={iconBtn} disabled={disabled} onClick={() => onAngle(Math.max(-90, angle - 5))} data-testid="roof-layout-rotate-all-left" title="Alle um 5° nach links drehen"><RotateCcw size={14} /></button>
          <button type="button" className={iconBtn} disabled={disabled} onClick={() => onAngle(Math.min(90, angle + 5))} data-testid="roof-layout-rotate-all-right" title="Alle um 5° nach rechts drehen"><RotateCw size={14} /></button>
        </RangeRow>
        <RangeRow title="Modulgröße" value={sizePct} unit="%" min={30} max={300} step={1} onChange={onSize} testid="roof-layout-size" />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <span className={label}>Alle Module</span>
        <div className="inline-flex rounded-lg overflow-hidden border border-zinc-700">
          <button type="button" onClick={() => onOrient(false)} disabled={disabled} className={segBtn(!landscape)} data-testid="roof-layout-orient-portrait">Hochkant</button>
          <button type="button" onClick={() => onOrient(true)} disabled={disabled} className={segBtn(landscape)} data-testid="roof-layout-orient-landscape">Quer</button>
        </div>
        <button type="button" onClick={onRearrange} disabled={disabled} data-testid="roof-layout-rearrange"
          className="h-9 px-3 rounded-lg border border-zinc-700 bg-zinc-900 text-zinc-100 text-[12px] font-bold inline-flex items-center gap-1.5 hover:bg-zinc-800 disabled:opacity-40">
          <LayoutGrid size={13} /> Neu anordnen
        </button>
        <div className="ml-auto inline-flex items-center gap-1.5">
          <button type="button" className={iconBtn} onClick={() => setZoom(Math.max(1, zoom - 0.5))} disabled={zoom <= 1} data-testid="roof-layout-zoom-out" title="Verkleinern"><ZoomOut size={14} /></button>
          <span className="font-mono text-[12px] text-zinc-300 w-10 text-center" data-testid="roof-layout-zoom-value">{zoom.toFixed(1).replace(".", ",")}×</span>
          <button type="button" className={iconBtn} onClick={() => setZoom(Math.min(5, zoom + 0.5))} disabled={zoom >= 5} data-testid="roof-layout-zoom-in" title="Vergrößern"><ZoomIn size={14} /></button>
        </div>
      </div>
    </div>
  );
}
